export const API_URI = "/rest"